import { EntryStatus } from 'chaika-enums';

export const enum EntryReviewEvents {
    StatusUpdated = 'EntryReviewStatusUpdated',
}

interface EntryReviewEventData<Body = {}> {
    body: Body;
    name: EntryReviewEvents;
    entityId: string;
    entityType: 'EntryReview';
    occurredOn: string;
}

export interface EntryReviewStatusUpdatedBody {
    entryId: string;
    status: EntryStatus;
    errorMessage?: string;
}

export interface EntryReviewStatusUpdatedEventData extends EntryReviewEventData<EntryReviewStatusUpdatedBody> {}
